import React from "preact/compat";
import { HeaderProps } from './header.type';

export const Header: React.FunctionComponent<HeaderProps> = ({
  t,
  site,
  totalC = 0,
  onClick
}) => {
    return (
        <div className={`betslip-header header-${site} d-flex justify-content-between align-items-center px-3`} role="button" onClick={onClick}>
            <div className="h5 d-flex justify-content-start align-items-center mb-0 lh-1">
              {t} 
              <span className={`betslip-counter h6 lh-1 ms-2 mb-0 p-0 border ${site !== "covers" ? "text-primary border-secondary" : "text-secondary border-primary"} rounded-circle position-relative`}>
                <span className={`position-absolute start-0 text-center w-100`}>{totalC}</span>
              </span>
            </div>
        </div>
    )
};